import { upperCase } from "lodash";

const VALIDATION_RULES_NAME: Dict<string> = {
  required: 'errorMessageRequired',
  requiredValue: 'errorMessageRequiredValue',
  maxLength: 'errorMessageMaxLength',
  minLength: 'errorMessageMinLength',
  digitsOnly: 'errorMessageDigitsOnly',
  isAlphabetic: 'errorMessageAlphaOnly',
  notEarlierThan: 'errorMessageNotEarlierThan',
  notLaterThan: 'errorMessageNotLaterThan',
  isAlphaNumeric:'errorMessageAlphaNumericOnly',
  isFiscalCode: 'errorMessageFiscalCode'
};

export default VALIDATION_RULES_NAME;
